<template>
  <div class="news">
    <img class="backimg" src="../../public/image/index_news.jpg" alt />

    <div class="con2">
      <div class="Htitle">
        <p class="t_en">NEWS CENTER</p>
        <p class="t_ch" v-show="isShow">新闻中心</p>
      </div>
      <swiper :options="swiperOptiona" ref="mySwipers" class="swiper2">
        <swiper-slide class="item" v-for="(item,index) in newsList" :key="index">
          <div class="news1">
            <img :src="`http://ys.sansg.com/${item[0].picurl}`" alt />
            <div class="text">
              <p class="time">{{item[0].posttime}}</p>
              <p class="title">{{item[0].title}}</p>
              <span class="btn" @click="gotoNews(item[0].id)">查看更多</span>
            </div>
          </div>
          <div class="news2">
            <img :src="`http://ys.sansg.com/${item[1].picurl}`" alt />
            <div class="text">
              <p class="time">{{item[1].posttime}}</p>
              <p class="title">{{item[1].title}}</p>
              <span class="btn" @click="gotoNews(item[1].id)">查看更多</span>
            </div>
          </div>
          <div class="news3">
            <div class="row1">
              <img :src="`http://ys.sansg.com/${item[2].picurl}`" alt @click="gotoNews(item[2].id)" />
              <div class="text">
                <p class="time">{{item[2].posttime}}</p>
                <p class="title">{{item[2].title}}</p>
              </div>
            </div>
            <div class="row1">
              <img :src="`http://ys.sansg.com/${item[3].picurl}`" alt @click="gotoNews(item[3].id)" />
              <div class="text">
                <p class="time">{{item[3].posttime}}</p>
                <p class="title">{{item[3].title}}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination" slot="pagination"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
      lan: "",
      isShow: true,
      newsList: [],
      swiperOptiona: {
        slidesPerView: 1, //一行显示3个
        speed: 1000,
        loop: true,
        // autoplay: {
        //   delay: 2000,
        //   disableOnInteraction: false,
        // },
        spaceBetween: 80,
        navigation: {
          prevEl: ".con2 .btn .prev",
          nextEl: ".con2 .btn .next",
        },
        pagination: {
          el: ".news .con2 .swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  props: ["list"],
  watch: {
    list(val) {
      this.newsList = this.group(val, 4);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs.mySwipers.swiper.init();
    });
    this.getLan();
    this.getShow();
  },
  methods: {
    group(array, subGroupLength) {
      if (!array) return;
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    gotoNews(id) {
      const link = `./newsinfo.html?id=${id}`;
      window.open(link, "_self");
    },
    getLan() {
      this.lan = localStorage.getItem("language");
    },
    getShow() {
      if(this.lan=='zh-CN'){
        this.isShow = true;
      }else{
        this.isShow = false;
        $('.t_en').addClass('t_ch');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.news {
  width: 100%;
  position: relative;
  overflow: hidden;
  .backimg {
    width: 100%;
    display: block;
    object-fit: contain;
  }
  .con2 {
    position: absolute;
    width: 100%;
    top: 0;
    left: 7%;
    bottom: 0;
    overflow-x: hidden;
    .Htitle {
      margin-top: 80px;
      .t_en {
        font-family: "SOURCEHANSANSCN-NORMAL";
        font-size: 40px;
        color: rgba(221, 221, 221, 0.5);
      }
      .t_ch {
        font-family: "SOURCEHANSANSCN-BOLD";
        font-size: 36px;
        color: white;
        position: relative;
        &::after {
          display: inline-block;
          content: "";
          position: absolute;
          bottom: 5px;
          left: 180px;
          height: 1px;
          width: 60px;
          background: linear-gradient(
            90deg,
            rgba(48, 170, 137, 1),
            rgba(0, 140, 214, 1)
          );
        }
      }
    }
    .swiper2 {
      position: absolute;
      height: 60%;
      width: 86%;
      top: 30%;
      // left: 50%;
      // transform: translateY(-50%);
      .item {
        display: flex;
        justify-content: space-between;
        .news1 {
          width: 25%;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          &::after {
            display: inline-block;
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-image: linear-gradient(white, #ffffffc7);
            transition: all 300ms;
          }
          &:hover {
            img {
              transform: scale(1.1);
            }
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 600ms;
          }
          .text {
            position: absolute;
            top: 70px;
            height: 70%;
            left: 10%;
            width: 80%;
            display: flex;
            flex-direction: column;
            z-index: 1;
            .time {
              color: #666666ff;
              font-family: "SOURCEHANSANSCN-NORMAL";
              font-size: 16px;
            }
            .title {
              font-size: 24px;
              font-family: "SOURCEHANSANSCN-MEDIUM";
              color: #333333;
              margin-top: 35px;
            }
            .btn {
              margin-top: auto;
              // margin-bottom: 70px;
              color: #008cd6ff;
              padding: 20px 40px;
              font-family: "SOURCEHANSANSCN-NORMAL";
              font-size: 14px;
              border: 1px solid #008cd6ff;
              align-self: flex-start;
              cursor: pointer;
              position: relative;
              z-index: 2;
              transition: all 300ms;
              &::after {
                display: inline-block;
                content: "";
                position: absolute;
                top: 0;
                height: 100%;
                left: 0;
                width: 0;
                background-color: rgba(0, 139, 214, 0.5);
                z-index: -1;
                transition: all 300ms;
              }
              &::before {
                display: inline-block;
                content: "";
                position: absolute;
                top: 0;
                height: 100%;
                right: 0;
                width: 0;
                background-color: rgba(0, 139, 214, 0.5);
                z-index: -1;
                transition: all 300ms;
              }
              &:hover {
                color: white;
                &::after {
                  width: 50%;
                }
                &::before {
                  width: 50%;
                }
              }
            }
          }
        }
        .news2 {
          width: 36%;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          &::after {
            display: inline-block;
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #008cd6;
            opacity: 0.7;
          }
          &:hover {
            img {
              transform: scale(1.1);
            }
          }
          img {
            display: block;
            height: 100%;
            width: 100%;
            object-fit: fill;
            transition: all 600ms;
          }
          .text {
            position: absolute;
            top: 70px;
            height: 70%;
            left: 8%;
            width: 80%;
            display: flex;
            flex-direction: column;
            z-index: 1;
            .time {
              color: white;
              font-family: "SOURCEHANSANSCN-NORMAL";
              font-size: 16px;
            }
            .title {
              font-size: 24px;
              font-family: "SOURCEHANSANSCN-MEDIUM";
              color: white;
              margin-top: 35px;
            }
            .btn {
              margin-top: auto;
              // margin-bottom: 70px;
              color: white;
              padding: 20px 40px;
              font-family: "SOURCEHANSANSCN-NORMAL";
              font-size: 14px;
              border: 1px solid white;
              // background-color: white;
              align-self: flex-start;
              cursor: pointer;
              position: relative;
              z-index: 2;
              transition: all 300ms;
              &::after {
                display: inline-block;
                content: "";
                position: absolute;
                top: 0;
                height: 100%;
                left: 0;
                width: 0;
                background-color: white;
                z-index: -1;
                transition: all 300ms;
              }
              &::before {
                display: inline-block;
                content: "";
                position: absolute;
                top: 0;
                height: 100%;
                right: 0;
                width: 0;
                background-color: white;
                z-index: -1;
                transition: all 300ms;
              }
              &:hover {
                color: #008cd6ff;
                &::after {
                  width: 50%;
                }
                &::before {
                  width: 50%;
                }
              }
            }
          }
        }
        .news3 {
          width: 37%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .row1 {
            position: relative;
            cursor: pointer;
            overflow: hidden;
            &:hover {
              img {
                transform: scale(1.1);
              }
            }
            img {
              width: 100%;
              display: block;
              object-fit: cover;
              transition: all 600ms;
              cursor: pointer;
              filter: brightness(0.4);
            }
            .text {
              position: absolute;
              top: 70px;
              height: 70%;
              left: 8%;
              width: 80%;
              display: flex;
              flex-direction: column;
              .time {
                color: white;
                font-family: "SOURCEHANSANSCN-NORMAL";
                font-size: 16px;
              }
              .title {
                font-size: 24px;
                font-family: "SOURCEHANSANSCN-MEDIUM";
                color: white;
                margin-top: 35px;
              }
            }
          }
          .row1:nth-child(1) {
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .news {
    .con2 {
      .swiper2 {
        .item {
          .news1 {
            .text {
              .title {
                font-size: 18px;
              }
            }
          }
          .news2 {
            .text {
              .title {
                font-size: 18px;
              }
            }
          }
          .news3 {
            .row1 {
              .text {
                top: 35px;
                .title {
                  font-size: 18px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width:1000px) {
  .news{
    height: 1000px;
    .backimg{
      height: 100%;
      object-fit: cover;
    }
    .con2{
      width: 90%;
      left: 5%;
      .Htitle{
        margin-top: 20px;
        .t_en{
          font-size: 20px;
        }
        .t_ch{
          font-size: 18px;
          &::after{
            left: 100px;
          }
        }
      }
      .swiper2{
        width: 100%;
        top: 10%;
        height: unset;
        .item{
          flex-wrap: wrap;
          .news1{
            width: 100%;
            margin-bottom: 10px;
            .text{
              top: 15px;
              .title{
                font-size: 14px;
                margin-top: 10px;
              }
              .btn{
                padding: 10px 20px;
              }
            }
          }
          .news2{
            width: 100%;
            margin-bottom: 10px;
            .text{
              top: 15px;
              .title{
                font-size: 14px;
                margin-top: 10px;
              }
              .btn{
                padding: 10px 20px;
              }
            }
          }
          .news3{
            width: 100%;
            .row1:nth-child(1){
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.swiper-pagination {
  right: 15%;
  width: 50%;
  top: 20%;
  bottom: unset;
  left: unset;
  text-align: end;
  padding-right: 20px;
}
.swiper-pagination >>> .swiper-pagination-bullet {
  width: 16px;
  height: 16px;
  background-color: white;
  opacity: 0.5;
  margin-left: 20px;
  position: relative;
  outline: none;
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  opacity: 1;
}
.swiper-pagination >>> .swiper-pagination-bullet-active::after {
  display: inline-block;
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  border: 1px solid white;
  border-radius: 50%;
}
@media screen and (max-width: 1000px) {
  .swiper-pagination{
    top: 4%;
    right: 0;
  }
}
</style>